import { useEffect, useState } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { Building2, Plug, KeyRound, ScrollText, CreditCard, LogOut, LayoutDashboard } from 'lucide-react';
import { api } from '../../api/client';
import { VippsDriftBanner } from '../../components/VippsDriftBanner';

interface Me {
  authenticated: boolean;
  username?: string;
  displayName?: string;
  role?: string;
}

const NAV: Array<{ to: string; label: string; icon: typeof LayoutDashboard; end?: boolean }> = [
  { to: '/admin', label: 'Dashbord', icon: LayoutDashboard, end: true },
  { to: '/admin/owners', label: 'Eiere', icon: Building2 },
  { to: '/admin/clients', label: 'API-klienter', icon: Plug },
  { to: '/admin/requests', label: 'Krav', icon: ScrollText },
];

export default function AdminLayout() {
  const [me, setMe] = useState<Me | null>(null);
  const nav = useNavigate();

  useEffect(() => {
    api
      .get<Me>('/api/admin/me')
      .then((r) => {
        if (!r.authenticated) nav('/admin/login');
        setMe(r);
      })
      .catch(() => nav('/admin/login'));
  }, [nav]);

  async function logout() {
    await api.post('/api/admin/logout').catch(() => {});
    nav('/admin/login');
  }

  if (!me) return null;
  if (!me.authenticated) return null;

  return (
    <div className="h-full flex">
      <aside className="w-60 bg-slate-900 text-slate-100 flex flex-col">
        <div className="px-5 py-5 border-b border-slate-800 flex items-center gap-2">
          <CreditCard size={22} className="text-brand" />
          <span className="font-semibold tracking-wide">Pay</span>
        </div>
        <nav className="flex-1 p-3 space-y-1">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end ?? false}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2 rounded text-sm ${
                  isActive ? 'bg-slate-800 text-white' : 'text-slate-300 hover:bg-slate-800'
                }`
              }
            >
              <n.icon size={18} />
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-slate-800 text-xs space-y-2">
          <div className="text-slate-400">Logget inn som</div>
          <div className="font-medium">{me.displayName}</div>
          <NavLink
            to="/admin/profil"
            className={({ isActive }) =>
              `flex items-center gap-2 ${isActive ? 'text-white' : 'text-slate-400 hover:text-white'}`
            }
          >
            <KeyRound size={14} /> Bytt passord
          </NavLink>
          <button
            onClick={logout}
            className="flex items-center gap-2 text-slate-400 hover:text-white"
          >
            <LogOut size={14} /> Logg ut
          </button>
        </div>
      </aside>
      <main className="flex-1 overflow-auto bg-slate-50">
        {/* Driftsstatus fra Vipps (status.vippsmobilepay.com) — vises bare når Vipps melder noe. */}
        <VippsDriftBanner />
        <Outlet />
      </main>
    </div>
  );
}
